<template>
  <div class="center-of-mass-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>Plumb Line Method</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：悬挂法找重心 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 支点 -->
            <circle :cx="pivotX" :cy="pivotY" r="4" fill="#888" />
            
            <!-- 悬挂的物体 (不规则多边形) -->
            <g :transform="`rotate(${angle}, ${pivotX}, ${pivotY})`">
                <path d="M 0 0 L 60 -40 L 100 20 L 40 80 L -20 40 Z" 
                  :transform="`translate(${pivotX}, ${pivotY})`" 
                  fill="rgba(0,210,255,0.2)" stroke="#00d2ff" stroke-width="2" />
                
                <!-- 物体坐标系内的重心标记 (预设) -->
                <circle :cx="pivotX + 35" :cy="pivotY + 25" r="3" fill="#ff4757" v-if="showCM" />
            </g>

            <!-- 铅垂线 -->
            <line :x1="pivotX" :y1="pivotY" :x2="pivotX" y2="200" stroke="#ffd700" stroke-width="1" stroke-dasharray="4,2" />
            
            <text x="50" y="40" fill="#888" font-size="10">通过悬挂法找到两条垂线的交点即为重心</text>
         </svg>

         <div class="hud-top">
            <div class="badge">当前悬挂点: {{ pivotPoint }}</div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row center">
               <el-button type="primary" size="mini" @click="changePivot">更换悬挂点</el-button>
               <el-button size="mini" @click="showCM = !showCM">{{ showCM ? '隐藏重心' : '显示重心结果' }}</el-button>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>物理详解：</strong>物体的各部分都受重力作用，但在研究运动时，可以认为重力集中作用于一点，即<strong>重心</strong>。对于形状不规则的薄板，可用<strong>悬挂法</strong>测定其重心位置。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CenterOfMassViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      pivotX: 200,
      pivotY: 40,
      angle: 0,
      pivotPoint: '顶点 A',
      showCM: false,
      running: true
    }
  },
  methods: {
    changePivot() {
       this.pivotPoint = this.pivotPoint === '顶点 A' ? '顶点 B' : '顶点 A';
       // Reset angle for simple visualization
       this.angle = 0;
    },
    animate() {
       if (!this.running) return;
       // Damped oscillation to settle
       const targetAngle = this.pivotPoint === '顶点 A' ? 15 : -25;
       this.angle = this.angle * 0.95 + targetAngle * 0.05;
       requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { this.running = false; }
}
</script>

<style scoped lang="scss">
.center-of-mass-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; .badge { color: #ffd700; border: 1px solid #ffd700; padding: 2px 8px; border-radius: 4px; font-size: 0.7rem; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row.center { display: flex; justify-content: center; gap: 15px; } }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
